module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-power-up-drongen-thumbnail.b967a1d6.png";